import { SafeAreaView, StyleSheet } from "react-native";
import React from "react";
import { useQuery } from "react-query";
import useApi from "../../../hooks/useAPI";
import { useAppDispatch, useAppSelector } from "../../../hooks/reduxHooks";
import { ActivityIndicator } from "react-native-paper";
import Cards from "./Cards";
import { showMessage } from "react-native-flash-message";
import { setCard } from "../../../store/slices/authSlice";

import { HomeScreenProps } from "../HomeStack";

const ID = () => {
  const api = useApi();
  const dispatch = useAppDispatch();
  const user = useAppSelector((s) => s.auth.subUser!);
  const { card } = { ...user };

  const { refetch, status } = useQuery(
    "isicCard",
    () => api.cards.getCardV2(user.id),
    {
      onSuccess: async (response) => {
        const { display_images, institution, expiry } = response.data;

        const result = await checkCardImageSource(
          display_images,
          institution,
          expiry
        );
        const updatedCard = result
          ? {
              ...response.data,
              display_images: { back: result.back, front: result.front },
            }
          : response.data;
        dispatch(setCard(updatedCard));
      },

      onError(err: any) {
        showMessage({
          type: "danger",
          message: "Não foi possível recuperar as informações da carteirinha.",
          description: "Tente novamente em alguns minutos.",
          duration: 5000,
        });
        dispatch(
          setCard({
            ...card,
            images: { ...card?.images, front: "Base-front-image" },
          })
        );
      },
    }
  );

  const checkCardImageSource = async (
    display_images: { back: string; front: string },
    institution: string,
    expirationDate: string
  ) => {
    const createdAt = Number(expirationDate.slice(0, 4)) - 1;

    if (display_images?.front !== null && display_images?.back !== null) {
      return false;
    }

    try {
      const response = await api.cards.getStandard(institution, createdAt);
      console.log(response.data)
      return response.data.display_images;
    } catch (error) {
      showMessage({
        type: "danger",
        message: "Não foi possível recuperar a imagem da carteirinha.",
        description: "Tente novamente em alguns minutos.",
        duration: 5000,
      });
      console.log(error.message);
      return null;
    }
  };

  return (
    <SafeAreaView style={styles.root}>
      {card?.images?.front !== undefined &&
      card?.images?.front !== "Base-front-image" &&
      status === "success" ? (
        <Cards />
      ) : (
        <ActivityIndicator size={24} style={{ flex: 1 }} />
      )}
    </SafeAreaView>
  );
};

export default ID;

const styles = StyleSheet.create({
  root: {
    flex: 1,
  },
});
